<script setup lang="ts">
import { ref } from "vue";
import { getUser, login } from "../../auth/api";
import { getLegacyApp } from "../../core/legacy-bridge";
import { t } from "../../i18n";
import { appStore } from "../../stores/app";

const email = ref("");
const password = ref("");

async function submit() {
    if (email.value === "" || password.value === "") return;

    const result = await login(email.value, password.value);

    if (result.failed) {
        appStore.loading = false;
        getLegacyApp().onLoginFailed();
        return;
    }

    if (result.success) {
        const user = await getUser();
        appStore.loading = false;
        getLegacyApp().onLoggedIn(user);
    }

    if (result.changePassword) {
        appStore.modal = "changePassword";
    }
}

function openForgotPassword() {
    appStore.modal = "forgotPassword";
}
</script>

<!-- Shown when appStore.page is "login" (set by showPage in app.ts) -->
<template>
    <div class="login-page page bulma-contextual" data-page="login" :class="{ 'is-shown': appStore.page === 'login' }">
        <div class="page__content columns is-gapless is-centered is-vcentered">
            <div class="column is-12-mobile is-10-tablet">

                <div class="columns is-gapless">
                    <div class="column is-12-mobile is-6-tablet is-3-widescreen">

                        <div class="login">
                            <section class="section">
                                <div class="mb-6">

                                    <h1 class="title is-1" v-html="t('page.login.header')"></h1>
                                    <p class="mb-6" v-html="t('page.login.body')"></p>

                                    <div class="simple-input field">
                                        <div class="control">
                                            <input id="email" v-model="email" name="email" type="email" class="input is-shadowless is-radiusless" placeholder="E-mail address*" @keydown.enter="submit" />
                                        </div>
                                    </div>
                                    <div class="simple-input field">
                                        <div class="control">
                                            <input id="password" v-model="password" name="password" type="password" class="input is-shadowless is-radiusless" placeholder="Password*" @keydown.enter="submit" />
                                        </div>
                                    </div>
                                    <div class="field mb-6">
                                        <div class="control">
                                            <a href="javascript:void(0);" id="forgotpassword-link" class="is-link" @click="openForgotPassword">New user / Forgot password</a>
                                        </div>
                                    </div>
                                    <div class="field">
                                        <div class="control">
                                            <button class="login-btn button is-default is-dark is-radiusless is-fullwidth" @click="submit">
                                                <span>Log in</span>
                                                <span class="icon is-small is-right">
                                                    <i class="fas fa-long-arrow-alt-right"></i>
                                                </span>
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
